// Manages which slide is visible in RjV1PersonalDetails multi-step form

export const generateInitialSlideState = (totalSlides) => {
  const state = {};
  for (let i = 1; i <= totalSlides; i++) {
    state[`showSlide${i}`] = i === 1 ? 'show' : 'd-none';
  }
  return state;
};

export const manageFormSlides = (state, action) => {
  switch (action.type) {
    case 'showSlide': {
      const { slide } = action.payload;
      // slide = 'next1', 'next2', ... or 'back2', 'back3', ...
      const isNext = slide.startsWith('next');
      const isBack = slide.startsWith('back');

      if (isNext) {
        const currentSlideNum = parseInt(slide.replace('next', ''));
        const nextSlideNum = currentSlideNum + 1;
        return {
          ...state,
          [`showSlide${currentSlideNum}`]: 'd-none',
          [`showSlide${nextSlideNum}`]: 'show',
        };
      }

      if (isBack) {
        const backToSlideNum = parseInt(slide.replace('back', ''));
        const fromSlideNum = backToSlideNum + 1;
        return {
          ...state,
          [`showSlide${fromSlideNum}`]: 'd-none',
          [`showSlide${backToSlideNum}`]: 'show',
        };
      }

      return state;
    }
    default:
      return state;
  }
};